import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import { Option } from '@/fo/ui/kit/listbox/base';
import { UiKitTextareaBase } from '@/fo/ui/kit/textarea/base';
import { useForm } from '@/fo/ui/mod/form/base';

import { AboutUserSection, FormFooter, SuccessMessage } from '../../components';
import { UserInfo } from '../../types';

import { formAction } from './formAction';
import { styles } from './QuestionForm.styles';

export interface QuestionFormProps {
  skinTypes: Option[];
  skinProblems: Option[];
  sku: string;
  onSuccess?: () => void;
  userInfo?: UserInfo;
  onClose?: () => void;
}

export function QuestionForm({
  skinTypes,
  skinProblems,
  sku,
  onSuccess,
  userInfo,
  onClose
}: QuestionFormProps) {
  const slots = styles();

  const t = useTranslations('review.form');

  const { getFieldProps, pending, isDirty, state, action } =
    useForm(formAction);

  const isSuccess = state.status === 'success';

  useEffect(() => {
    if (isSuccess) {
      onSuccess?.();
    }
  }, [isSuccess, onSuccess]);

  if (isSuccess) {
    return (
      <SuccessMessage
        type="question"
        onClick={onClose}
      />
    );
  }

  return (
    <form
      className={slots.base()}
      noValidate
      action={action}
    >
      <input
        type="hidden"
        name="sku"
        value={sku}
      />
      <div className={slots.formContainer()}>
        <div>
          <h3 className={slots.formTitle()}>{t('question.title')}</h3>
          <UiKitTextareaBase
            required
            name="question"
            label={t('question.label')}
            placeholder={t('question.placeholder')}
            {...getFieldProps('question')}
          />
        </div>
        <div>
          <h3 className={slots.formTitle()}>{t('aboutUser.title')}</h3>
          <AboutUserSection
            skinTypes={skinTypes}
            skinProblems={skinProblems}
            getFieldProps={getFieldProps}
            userInfo={userInfo}
          />
        </div>
      </div>
      <FormFooter
        type="question"
        pending={pending}
        isDirty={isDirty}
        email={userInfo?.email}
        isSubscribed={userInfo?.is_subscribed}
      />
    </form>
  );
}
